import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStarWand: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconStarWand"><Path d="M5.25685 1.4353L6.42948 8.8692L1.11084 14.1942L7.64741 15.2337L3.02219 21.4L4.22215 22.3001L8.89686 16.0678L11.9651 22.0796L15.3863 15.3763L22.8194 14.1942L17.5008 8.8692L18.6734 1.4353L11.9651 4.84764L5.25685 1.4353Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStarWand;
